{
  "alert": "Varning",
  "dismiss": "Avvisa"
}
